import oneDayInAlex from './itineraries/one-day-in-alex.json';
import cafesAndCorniche from './itineraries/cafes-and-corniche.json';
import historicAlex from './itineraries/historic-alex.json';
import sunsetRoute from './itineraries/sunset-route.json';
import weekendInAlex from './itineraries/weekend-in-alex.json';
import alexForBookLovers from './itineraries/alex-for-book-lovers.json';
import seaCornicheWalk from './itineraries/sea-corniche-walk.json';
import familyDayOut from './itineraries/family-day-out.json';
import anfoushiWalk from './itineraries/anfoushi-walk.json';

export const TRANSPORT_ICONS: Record<string, string> = {
  walk: 'Footprints',
  taxi: 'Car',
  tram: 'Train',
  uber: 'Car'
};

export const DIFFICULTY_COLORS: Record<string, string> = {
  Easy: 'bg-green-100 text-green-800',
  Moderate: 'bg-yellow-100 text-yellow-800',
  Hard: 'bg-red-100 text-red-800'
};

export const ITINERARIES = [
oneDayInAlex,
weekendInAlex,
cafesAndCorniche,
historicAlex,
sunsetRoute,
seaCornicheWalk,
alexForBookLovers,
familyDayOut,
anfoushiWalk];